module.exports = __webpack_public_path__ + "img/venus11.c2c5e705.png";